import { FunctionComponent, useState } from "react";
import { useAuth } from "@app/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Button } from "./Button";

const AuthScreen: FunctionComponent = () => {
  const { state, handleAuthAttempt, error } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = (e: { preventDefault?: () => unknown }) => {
    e.preventDefault?.();
    // Rejection is reported through the auth context's `error`; swallowed here so an
    // unhandled rejection does not reach the console on a mistyped password.
    handleAuthAttempt({ username, password }).catch(() => {});
  };

  if (state === "authenticated") {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-sunken p-4">
      <form
        onSubmit={onSubmit}
        className="flex w-full max-w-sm flex-col gap-4 rounded-xl border border-line
          bg-surface-raised p-6 shadow-sm"
      >
        <div className="flex flex-col gap-1">
          <h1 className="text-lg font-semibold text-ink">Sign in</h1>
          <p className="text-sm text-ink-muted">
            Editing needs an account. The list is readable without one.
          </p>
        </div>

        <label className="flex flex-col gap-1.5">
          <span className="text-sm font-medium text-ink">Username</span>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            className="h-10 rounded-md border border-line-strong bg-surface px-3 text-ink
              placeholder:text-ink-faint focus:border-accent focus:outline-1 focus:outline-accent"
          />
        </label>

        <label className="flex flex-col gap-1.5">
          <span className="text-sm font-medium text-ink">Password</span>
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            autoComplete="current-password"
            required
            className="h-10 rounded-md border border-line-strong bg-surface px-3 text-ink
              placeholder:text-ink-faint focus:border-accent focus:outline-1 focus:outline-accent"
          />
        </label>

        <Button type="submit" variant="primary" size="md">
          Sign in
        </Button>

        {error ? (
          // `role="alert"` so the failure is announced: it appears without anything
          // moving focus, and is otherwise silent to a screen reader.
          <p role="alert" className="text-center text-sm text-danger">
            {error.message}
          </p>
        ) : null}
      </form>
    </div>
  );
};

export default AuthScreen;
